"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _gatsby = require("gatsby");

var _lodash = require("lodash");

var _useNavbarItems3 = require("../../../src/hooks/use-navbar-items");

var _useFeaturedTags2 = require("../../../src/hooks/use-featured-tags");

var _useLanguageList3 = require("../../../src/hooks/use-language-list");

var _changeLanguageSprite = _interopRequireDefault(require("../src/img/changeLanguage.sprite.svg"));

function Navbar(props) {
  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      navBarActiveClass = _useState2[0],
      setNavBarActiveClass = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      dropdownInfoActiveClass = _useState4[0],
      setDropdownInfoActiveClass = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      dropdownSectionsActiveClass = _useState6[0],
      setDropdownSectionsActiveClass = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      dropdownLangActiveClass = _useState8[0],
      setDropdownLangActiveClass = _useState8[1];

  var slug = props.slug;

  if (!(props.langKey === "en" || props.langKey === undefined)) {
    slug = "".concat(slug === undefined ? "" : slug.substring(3));
  }

  function toggleHamburger() {
    setNavBarActiveClass(navBarActiveClass === "" ? 'is-active' : "");
  }

  function toggleDropdownInfo(props) {
    if (props === 'SECTIONS') {
      setDropdownSectionsActiveClass(dropdownSectionsActiveClass === "" ? 'is-active' : "");
    } else {
      setDropdownInfoActiveClass(dropdownInfoActiveClass === "" ? 'is-active' : "");
    }
  }

  function toggleDropdownLang() {
    setDropdownLangActiveClass(dropdownLangActiveClass === "" ? 'is-active' : "");
  }

  var _useNavbarItems = (0, _useNavbarItems3.useNavbarItems)(),
      _useNavbarItems2 = (0, _slicedToArray2["default"])(_useNavbarItems, 1),
      node = _useNavbarItems2[0];

  var _useLanguageList = (0, _useLanguageList3.useLanguageList)(),
      _useLanguageList2 = (0, _slicedToArray2["default"])(_useLanguageList, 1),
      nodeLang = _useLanguageList2[0];

  var frontmatter = node.node.frontmatter;
  var languages = nodeLang.node.frontmatter.languages;
  var isFixedTop = frontmatter.isFixedTop ? 'is-fixed-top' : '';
  var logo = frontmatter.logo;
  var logoIsBold = frontmatter.logo.isBold ? 'has-text-weight-bold' : '';
  var languageSelector = frontmatter.languageSelector;
  var itemAlign = '';

  switch (frontmatter.item.align) {
    case 'left':
      itemAlign = 'navbar-start';
      break;

    case 'right':
      itemAlign = 'navbar-end';
      break;
  }

  var itemFontSizeWidescreen = frontmatter.item.fontSizeWidescreen + '-widescreen';
  var itemFontSizeTablet = frontmatter.item.fontSizeTablet + '-tablet';
  var itemFontSizeMobile = frontmatter.item.fontSizeMobile + '-mobile';
  var itemIsBold = frontmatter.item.isBold ? 'has-text-weight-bold' : '';

  var _useFeaturedTags = (0, _useFeaturedTags2.useFeaturedTags)(),
      tags = _useFeaturedTags.tagList;

  return (
    /*#__PURE__*/
    _react["default"].createElement("nav", {
      className: "navbar ".concat(isFixedTop),
      role: "navigation",
      "aria-label": "main-navigation"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "container"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "navbar-brand"
    },
    /*#__PURE__*/
    _react["default"].createElement(_gatsby.Link, {
      className: "navbar-item",
      title: "Logo",
      to: "".concat(props.langKey === "en" || props.langKey === undefined ? "" : props.langKey, "/")
    }, logo.useImage &&
    /*#__PURE__*/
    _react["default"].createElement("img", {
      src: props.logo,
      alt: logo.siteName
    }), logo.useSiteName &&
    /*#__PURE__*/
    _react["default"].createElement("p", {
      className: "".concat(logo.fontSize, " ").concat(logoIsBold),
      style: {
        letterSpacing: "".concat(logo.letterSpacing)
      }
    }, logo.siteName)),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "navbar-burger burger ".concat(navBarActiveClass),
      "data-target": "navMenu",
      onClick: function onClick() {
        return toggleHamburger();
      },
      onKeyPress: toggleHamburger,
      role: "menuitem",
      tabIndex: "0"
    },
    /*#__PURE__*/
    _react["default"].createElement("span", null),
    /*#__PURE__*/
    _react["default"].createElement("span", null),
    /*#__PURE__*/
    _react["default"].createElement("span", null))),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      id: "navMenu",
      className: "navbar-menu ".concat(navBarActiveClass)
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "".concat(itemAlign, " has-text-centered")
    }, frontmatter.items.map(function (item) {
      return item.link != null ?
      /*#__PURE__*/
      _react["default"].createElement(_react["default"].Fragment, null, item.translations.filter(function (translation) {
        return translation.langKey === props.langKey;
      }).map(function (translation) {
        return (
          /*#__PURE__*/
          _react["default"].createElement(_gatsby.Link, {
            className: "navbar-item ".concat(itemFontSizeWidescreen, " ").concat(itemFontSizeTablet, " ").concat(itemFontSizeMobile, " ").concat(itemIsBold),
            to: "".concat(props.langKey === "en" || props.langKey === undefined ? "" : props.langKey).concat(item.link)
          }, translation.name)
        );
      })) :
      /*#__PURE__*/
      _react["default"].createElement("div", {
        className: "navbar-item has-dropdown is-hoverable ".concat(itemIsBold)
      },
      /*#__PURE__*/
      _react["default"].createElement(_react["default"].Fragment, null, item.translations.filter(function (translation) {
        return translation.langKey === props.langKey;
      }).map(function (translation) {
        return (
          /*#__PURE__*/
          _react["default"].createElement("span", {
            className: "navbar-link ".concat(itemFontSizeWidescreen, " ").concat(itemFontSizeTablet, " ").concat(itemFontSizeMobile),
            onClick: function onClick() {
              return toggleDropdownInfo(translation.name);
            },
            onKeyPress: toggleDropdownInfo,
            role: "menuitem",
            tabindex: "0"
          }, translation.name)
        );
      })),
      /*#__PURE__*/
      _react["default"].createElement(_react["default"].Fragment, null, item.subItems != null &&
      /*#__PURE__*/
      _react["default"].createElement(_react["default"].Fragment, null, !item.tags ?
      /*#__PURE__*/
      _react["default"].createElement("div", {
        className: "navbar-dropdown ".concat(dropdownInfoActiveClass)
      }, item.subItems.map(function (subItem) {
        return (
          /*#__PURE__*/
          _react["default"].createElement(_react["default"].Fragment, null, subItem.translations.filter(function (translation) {
            return translation.langKey === props.langKey;
          }).map(function (translation) {
            return (
              /*#__PURE__*/
              _react["default"].createElement(_gatsby.Link, {
                className: "navbar-item",
                to: "".concat(props.langKey === "en" || props.langKey === undefined ? "" : props.langKey).concat(subItem.link)
              }, translation.name)
            );
          }))
        );
      })) :
      /*#__PURE__*/
      _react["default"].createElement("div", {
        className: "navbar-dropdown ".concat(dropdownSectionsActiveClass)
      }, tags.filter(function (tag) {
        return tag.featured;
      }).map(function (tag) {
        return (
          /*#__PURE__*/
          _react["default"].createElement("div", null, tag.translations && tag.translations.filter(function (translation) {
            return translation.langKey === props.langKey;
          }).map(function (translation) {
            return (
              /*#__PURE__*/
              _react["default"].createElement(_gatsby.Link, {
                className: "navbar-item",
                to: "".concat(props.langKey === "en" || props.langKey === undefined ? "" : props.langKey).concat(tag.tag)
              }, (0, _lodash.startCase)(translation.tagDisplay))
            );
          }))
        );
      }), item.subItems.map(function (subItem) {
        return (
          /*#__PURE__*/
          _react["default"].createElement(_react["default"].Fragment, null, subItem.translations.filter(function (translation) {
            return translation.langKey === props.langKey;
          }).map(function (translation) {
            return (
              /*#__PURE__*/
              _react["default"].createElement(_gatsby.Link, {
                className: "navbar-item",
                to: "".concat(props.langKey === "en" || props.langKey === undefined ? "" : props.langKey).concat(subItem.link)
              }, translation.name)
            );
          }))
        );
      })))));
    })), languageSelector.use &&
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "navbar-item has-dropdown is-hoverable"
    },
    /*#__PURE__*/
    _react["default"].createElement("span", {
      className: "navbar-link",
      onClick: function onClick() {
        return toggleDropdownLang();
      },
      onKeyPress: toggleDropdownLang,
      role: "menuitem",
      tabindex: "0"
    },
    /*#__PURE__*/
    _react["default"].createElement("img", {
      src: _changeLanguageSprite["default"],
      alt: "Language Selector",
      style: {
        width: '20px',
        height: '20px'
      }
    })),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "navbar-dropdown ".concat(dropdownLangActiveClass, " has-text-centered")
    }, languages.map(function (language) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_gatsby.Link, {
          className: "navbar-item ".concat(itemFontSizeWidescreen, " ").concat(itemFontSizeTablet, " ").concat(itemFontSizeMobile),
          to: "/" + "".concat(language.langKey === 'en' ? '' : language.langKey + '/') + "".concat(slug)
        }, language.langName)
      );
    }))))))
  );
}

var _default = Navbar;
exports["default"] = _default;